<a 
  class="edit-route__banner"
  (click)="handleBannerClick()"
>
  <span class="banner__title ci-paragraph-p1-regular">
    {{ 'Descubre cómo modificar tu itinerario' | translate }}
  </span>
  <ci-icon-button
    class="banner__close-button"
    name="close" 
    type="standard"
    (click)="handleCloseClick()"
  ></ci-icon-button>
</a>
